module.exports = __webpack_public_path__ + "img/FullAnimation1.742bdcfe.png";